var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresaleDecoration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 469 109",
    style: {
      enableBackground: "new 0 0 469 109"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D2D4C2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1852",
    transform: "translate(-725.946 -1443.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHORT_frame_02",
    transform: "translate(740.246 1443.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    className: "st0",
    d: "M382.7,55.1c-0.6-0.3-1.2-0.7-1.8-1c0.6-0.3,1.2-0.7,1.8-1c8.1-4.8,15.7-10.5,22.7-16.8 l1.6-1.5l-1.2-1.7c-3.5-4.8-6.5-9.9-9-15.3l-1.6-3.5l-2.9,2.7c-0.5,0.4-1,0.8-1.4,1.3c-0.3,2.3-0.3,4.7,0,7 c0.8-0.7,1.7-1.4,2.5-2.1c2,3.8,4.2,7.5,6.6,11c-5.6,4.9-11.5,9.4-17.8,13.3c-2.1,1.3-4.3,2.6-6.4,3.8c0.1,1,0.1,1.9,0.1,2.9 c0,1,0,1.9-0.1,2.9c2.2,1.2,4.3,2.5,6.4,3.8c6.3,3.9,12.2,8.4,17.8,13.3c-2.4,3.5-4.6,7.2-6.6,11c-0.8-0.7-1.7-1.4-2.5-2.1 c-0.2,2.3-0.2,4.7,0,7c0.5,0.4,1,0.8,1.4,1.3l2.9,2.7l1.6-3.5c2.5-5.4,5.5-10.5,9-15.3l1.2-1.7l-1.6-1.5 C398.4,65.7,390.8,60,382.7,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    className: "st0",
    d: "M399.8,62.6c9.3-5.1,33.6-8.2,38.6-8.5c-5-0.3-29.3-3.4-38.6-8.5c-1.4,1.2-2.8,2.3-4.3,3.4 c3.5,2.4,7.4,4.1,11.5,5.1c-4.1,1-8,2.8-11.5,5.1C397,60.3,398.4,61.4,399.8,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    className: "st0",
    d: "M378.2,34.5c0.2-0.1,0.3-0.2,0.5-0.3c0.5-0.3,0.9-0.6,1.4-0.9c-0.4-1.9-0.7-3.8-0.9-5.8 c-1,0.7-2.1,1.4-3.1,2.1c-0.1,0.1-0.3,0.2-0.4,0.3l-10.4,6.9v34.5l10.4,6.9c0.1,0.1,0.3,0.2,0.4,0.3c1,0.7,2.1,1.4,3.1,2.1 c0.3-2.2,0.5-4,0.9-5.8c-0.5-0.3-0.9-0.6-1.4-0.9c-0.2-0.1-0.3-0.2-0.5-0.3l-7.4-4.9V39.3L378.2,34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    className: "st0",
    d: "M52.3,90c0.3-2.3,0.3-4.7,0-7c-0.8,0.7-1.7,1.4-2.5,2.1c-2-3.8-4.2-7.5-6.6-11 c5.6-4.9,11.5-9.4,17.8-13.3c2.1-1.3,4.3-2.6,6.4-3.8c-0.1-1-0.1-1.9-0.1-2.9c0-1,0-1.9,0.1-2.9c-2.2-1.2-4.3-2.5-6.4-3.8 c-6.3-3.9-12.2-8.4-17.8-13.3c2.4-3.5,4.6-7.2,6.6-11c0.8,0.7,1.7,1.4,2.5,2.1c0.3-2.3,0.3-4.7,0-7c-0.5-0.4-1-0.8-1.4-1.3 L48,14.2l-1.6,3.5c-2.5,5.4-5.5,10.5-9,15.3l-1.2,1.7l1.6,1.5c7,6.4,14.6,12,22.7,16.8c0.6,0.4,1.2,0.7,1.8,1 c-0.6,0.3-1.2,0.7-1.8,1c-8.1,4.9-15.8,10.6-22.8,16.9l-1.6,1.5l1.2,1.7c3.5,4.8,6.5,9.9,9,15.3l1.6,3.5l2.9-2.7 C51.4,90.8,51.8,90.4,52.3,90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    className: "st0",
    d: "M43.3,45.6C34,50.7,9.7,53.8,4.7,54.1c5,0.3,29.3,3.4,38.6,8.5c1.4-1.2,2.8-2.3,4.3-3.4 c-3.5-2.4-7.4-4.1-11.5-5.1c4.1-1,8-2.8,11.5-5.1C46.1,47.9,44.7,46.8,43.3,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    className: "st0",
    d: "M64.9,34.5l7.4,4.9v29.5l-7.4,4.9c-0.2,0.1-0.3,0.2-0.5,0.3c-0.5,0.3-0.9,0.6-1.4,0.9 c0.4,1.9,0.7,3.8,0.9,5.8c1-0.7,2.1-1.4,3.1-2.1c0.1-0.1,0.3-0.2,0.4-0.3l10.4-6.9V36.8l-10.4-6.9c-0.1-0.1-0.3-0.2-0.4-0.3 c-1-0.7-2.1-1.4-3.1-2.1c-0.3,2.2-0.5,4-0.9,5.8c0.5,0.3,0.9,0.6,1.4,0.9C64.6,34.3,64.7,34.4,64.9,34.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    className: "st0",
    d: "M389.6,73.8c0.5-1,1-2,1.6-2.9c-1.4-1.1-2.9-2.3-4.3-3.4c-1,1.4-1.8,2.9-2.5,4.4 c-4,9-3.1,19.4,2.4,27.5c-0.8,1.3-1.8,2.5-2.7,3.7H59c-1-1.2-1.9-2.4-2.7-3.7c5.5-8.1,6.4-18.5,2.4-27.5c-0.7-1.5-1.5-3-2.5-4.4 c-1.4,1.1-2.9,2.3-4.3,3.4c0.6,0.9,1.2,1.9,1.6,2.9c3.5,8,2.4,17.2-2.8,24.1l-1,1.3l0.9,1.4c1.7,2.7,3.6,5.2,5.7,7.5h330.6 c2.1-2.4,4-4.9,5.7-7.5l0.9-1.4l-1-1.3C387.2,91,386.1,81.8,389.6,73.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    className: "st0",
    d: "M370.1,22.3c0.7-0.5,1.4-0.9,2-1.4c0.2-2.3,0.7-4.5,1.4-6.7H69.6c0.7,2.2,1.1,4.4,1.4,6.7 c0.6,0.4,1.3,0.9,2,1.4l15,10V76l-15,9.8c-0.7,0.5-1.4,0.9-2.1,1.4c-0.2,2.3-0.7,4.5-1.4,6.7h303.9c-0.7-2.2-1.1-4.4-1.4-6.7 c-0.7-0.5-1.4-1-2-1.4l-15-10V32.2L370.1,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    className: "st0",
    d: "M53.4,34.3c-0.5,1-1,2-1.6,2.9c1.4,1.1,2.9,2.3,4.3,3.4c1-1.4,1.8-2.9,2.5-4.4 c4-9,3.1-19.4-2.4-27.5C57.1,7.5,58,6.3,59,5.1h325.1c1,1.2,1.9,2.4,2.7,3.7c-5.5,8.1-6.4,18.5-2.4,27.5c0.7,1.5,1.5,3,2.5,4.4 c1.4-1.1,2.9-2.3,4.3-3.4c-0.6-0.9-1.2-1.9-1.6-2.9c-3.5-8-2.4-17.2,2.8-24.1l1-1.3l-0.9-1.4c-1.7-2.7-3.6-5.2-5.7-7.5H56.2 c-2.1,2.4-4,4.9-5.7,7.5L49.6,9l1,1.3C55.8,17.2,56.9,26.4,53.4,34.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresaleDecoration);
export default __webpack_public_path__ + "static/media/presale_decoration.85f931e237813e400807b6b5ffb710f5.svg";
export { ForwardRef as ReactComponent };